import MarkerCollection from '@/lib/map-control/collection/MarkerCollection';
export default class WorkerMarkerCollection extends MarkerCollection {
    /**
     * 워커 마커 추가
     * @param workerData 워커 데이터
     */
    addMarker(workerData) {
        const mkWorker = this.createMarker(this.mapControl.marker.WORKER, workerData);
        // 기존 데이터 동기화 프로세스
        const oldMarker = this.getMarker(mkWorker.id);
        mkWorker.relatedWeight = oldMarker ? oldMarker.relatedWeight : 0;
        // 이벤트 등록
        this.naver.maps.Event.addListener(mkWorker.getNaverMarker, 'click', (value) => {
            this.clickCallback(value.overlay.origin);
        });
        // 지도 노출 여부 프로세스
        // 라이더마커 숨김 설정 활성화 시에는 라이더 마커 보이지 않기
        const isShow = mkWorker.computeIsShow();
        if (isShow) {
            mkWorker.setMap(this.mapInstance);
        }
        else {
            mkWorker.setMap(null);
        }
        super.add(mkWorker.id, mkWorker);
        return mkWorker;
    }
}
